<template>
  <div class="flex min-h-[calc(100vh-125px)]">
    <div
      v-if="props.menu"
      :class="
        twJoin(
          'min-w-[168px] bg-gray-10',
          `relative before:content-[''] before:absolute before:w-screen before:h-full before:top-0 before:right-0 before:pointer-events-none before:bg-gray-10`,
          props.menu.blockItems &&
            props.menu.blockItems?.items?.length > 0 &&
            'hidden'
        )
      "
    >
      <div
        :class="
          twJoin(
            ``,
            `relative before:content-[''] before:absolute before:w-screen before:h-full before:top-0 before:right-0 before:pointer-events-none`,
            subMenu == props.menu.title &&
              'before:bg-primary-tangerine text-primary-white fill-primary-white'
          )
        "
        @mouseenter="() => handleSetSubMenu(props.menu?.title ?? '')"
      >
        <NuxtLinkLocale
          :to="props.menu.url"
          class="block py-4 font-medium relative"
          @click="emit('close')"
        >
          {{ props.menu?.title }}
        </NuxtLinkLocale>
      </div>

      <div
        v-for="(list, index) in props.menu.list"
        :key="index"
        :class="
          twJoin(
            `py-4 pr-8 cursor-pointer`,
            `relative before:content-[''] before:absolute before:w-screen before:h-full before:top-0 before:right-0 before:pointer-events-none`,
            subMenu == list.title &&
              'before:bg-primary-tangerine text-primary-white fill-primary-white'
          )
        "
        @mouseenter="() => handleSetSubMenu(list.title)"
      >
        <div class="relative z-10 flex items-center justify-between">
          <div class="font-medium">{{ list.title }}</div>
          <Icon name="chevron-right" />
        </div>
      </div>
    </div>

    <div v-if="props.menu?.blockItems" class="col-start-1 col-end-4 py-6">
      <div
        class="pb-4 mb-4 text-xl font-medium border-dashed border-b-2 border-border-divider"
      >
        {{ props.menu?.blockItems.title }}
      </div>
      <div class="grid grid-cols-3 gap-x-5">
        <div
          v-for="(blockItem, blockItemIndex) in props.menu?.blockItems.items"
          :key="blockItemIndex"
        >
          <NuxtLinkLocale :to="blockItem.buttonUrl" @click="emit('close')">
            <img
              alt=""
              :src="blockItem.imageUrl"
              class="h-[120px] w-full object-cover rounded-lg"
            />
            <div
              class="pb-4 mb-4 mt-4 text-xl font-medium border-dashed border-b-2 border-border-divider"
            >
              {{
                locale === 'en'
                  ? blockItem.titleEn
                  : blockItem.titleTh || blockItem.titleEn
              }}
            </div>
            <div class="mb-[10px]">
              {{
                locale === 'en'
                  ? blockItem.descriptionEn
                  : blockItem.descriptionTh || blockItem.descriptionEn
              }}
            </div>

            <div class="text-primary-tangerine font-bold underline">
              {{ blockItem.buttonTitle }}
            </div>
          </NuxtLinkLocale>
        </div>
      </div>
    </div>
    <div
      :class="
        twJoin(
          'py-6 pl-6 w-full flex *:flex-1 gap-x-5 ',
          props.menu?.blockItems && 'xl:max-w-[256px]'
        )
      "
    >
      <div
        v-for="(items, index) in activeList"
        :key="index"
        :class="twJoin('grid grid-cols-4 gap-x-5')"
      >
        <div
          v-if="!props.menu?.blockItems"
          :class="
            twJoin(
              'grid content-start col-start-1 gap-x-5 ',
              items.cardItems.length <= 2 && 'grid-cols-3 col-end-4',
              items.cardItems.length > 2 &&
                items.linkItems.length > 0 &&
                'grid-cols-2 col-end-3',
              items.linkItems?.length == 0 && 'hidden'
            )
          "
        >
          <div
            v-for="(linkItem, linkIndex) in items.linkItems"
            :key="linkIndex"
            class="mb-5"
          >
            <div
              class="pb-4 mb-4 text-xl font-medium border-dashed border-b-2 border-border-divider"
            >
              {{ linkItem.title }}
            </div>
            <div class="space-y-[10px] text-base">
              <NuxtLinkLocale
                v-for="item in linkItem.items"
                :key="item.title"
                :to="item.url"
                class="flex items-center gap-x-2 hover:opacity-50"
                @click="emit('close')"
              >
                <div v-if="item.imageUrl">
                  <img
                    alt=""
                    :src="item.imageUrl"
                    class="w-10 h-10 rounded-full object-cover border border-border-divider"
                  />
                </div>
                <div>{{ item.title }}</div>
              </NuxtLinkLocale>
              <NuxtLinkLocale
                :to="linkItem.url"
                class="block text-primary-tangerine font-bold underline hover:opacity-50"
                @click="emit('close')"
              >
                {{ linkItem.footerTitle }}
              </NuxtLinkLocale>
            </div>
          </div>
        </div>
        <div
          :class="
            twJoin(
              items.cardItems.length > 2 &&
                items.linkItems.length > 0 &&
                'col-start-3 col-end-5',
              items.cardItems.length > 0 &&
                items.linkItems.length === 0 &&
                'col-start-1 col-end-5',
              props.menu?.blockItems &&
                props.menu?.blockItems.items.length > 0 &&
                'col-start-1 col-end-5'
            )
          "
        >
          <div
            v-for="(cardItem, cardItemIndex) in items.cardItems"
            :key="cardItemIndex"
          >
            <div
              class="pb-4 mb-4 text-xl font-medium border-dashed border-b-2 border-border-divider"
            >
              {{ cardItem.title }}
            </div>
            <div
              :class="
                twJoin(
                  'flex flex-wrap gap-y-6 gap-x-6',
                  (items.cardItems.length > 2 || items.linkItems.length == 0) &&
                    'grid'
                )
              "
              :style="{
                gridTemplateColumns: `repeat(${
                  items.linkItems.length == 0
                    ? (items.linkItems?.length || 0) == 0 &&
                      !(
                        props.menu?.blockItems &&
                        props.menu?.blockItems.items.length > 0
                      )
                      ? 4
                      : 1
                    : Math.ceil(items.linkItems.length / 2)
                }, minmax(0, 1fr))`
              }"
            >
              <NuxtLinkLocale
                v-for="card in cardItem.items"
                :key="card.title"
                class="w-full hover:opacity-50"
                :to="card.url"
                @click="emit('close')"
              >
                <div class="relative w-full pt-[100%]">
                  <div
                    class="absolute top-0 left-0 w-full h-full bg-primary-white rounded-xl"
                  >
                    <img
                      alt=""
                      :src="card.imageUrl"
                      class="w-full h-full object-cover border border-border-divider rounded-xl"
                    />
                    <div
                      class="absolute w-6 h-6 right-0 bottom-[48px] rounded-full border-b border-border-divider -rotate-45 border-l border-l-transparent border-r border-r-transparent"
                    />
                    <div
                      class="absolute w-6 h-6 right-[48px] bottom-0 rounded-full border-b border-border-divider -rotate-45 border-l border-l-transparent border-r border-r-transparent"
                    />
                    <div
                      :class="
                        twJoin(
                          'absolute bottom-0 right-0 z-10 pt-2 pl-2 bg-primary-white rounded-tl-lg',
                          'border-t border-l border-border-divider',
                          `after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-3 after:h-3 after:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_white_12px)] after:rotate-180 after:-translate-x-[100%]`,
                          `before:content-[''] before:absolute before:right-0 before:top-0 before:w-3 before:h-3 before:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_white_12px)] before:rotate-180 before:-translate-y-[100%]`
                        )
                      "
                    >
                      <div
                        class="w-10 h-10 bg-black flex items-center justify-center rounded-lg"
                      >
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 1.25V15.25C21 15.8125 20.5 16.25 20 16.25C19.4375 16.25 19 15.8125 19 15.25V3.6875L2.6875 20C2.5 20.1875 2.25 20.25 2 20.25C1.6875 20.25 1.4375 20.1875 1.25 20C0.875 19.625 0.875 18.9375 1.25 18.5625L17.5625 2.25H5.9375C5.4375 2.25 4.9375 1.75 5 1.25C5 0.6875 5.4375 0.25 6 0.25H20C20.5 0.25 21 0.75 21 1.25Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-primary-white relative z-10 pt-4">
                  {{ card.title }}
                </div>
              </NuxtLinkLocale>
            </div>
            <div v-if="cardItem.footerTitle && cardItem.url" class="mt-4">
              <NuxtLinkLocale
                v-if="cardItem.footerTitle && cardItem.url"
                :to="cardItem.url"
                class="inline text-primary-tangerine font-bold underline hover:opacity-50"
                @click="emit('close')"
              >
                {{ cardItem.footerTitle }}
              </NuxtLinkLocale>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { filter } from 'lodash-es'
import { twJoin } from 'tailwind-merge'

const emit = defineEmits<{
  (e: 'close'): void
}>()

const props = defineProps<{
  menu?: {
    title: string
    titleMobile: string
    url: string
    blockItems?: {
      title: string
      items: {
        titleEn: string
        titleTh: string
        imageUrl: string
        descriptionEn: string
        descriptionTh: string
        buttonTitle: string
        buttonUrl: string
      }[]
    }
    list: {
      title: string
      linkItems: {
        title: string
        url: string
        footerTitle: string
        items: { title: string; url: string; imageUrl?: string }[]
      }[]
      cardItems: {
        title: string
        url?: string
        footerTitle?: string
        items: { title: string; url: string; imageUrl: string }[]
      }[]
    }[]
  }
}>()

const subMenu = ref<null | string>(props.menu?.list[0]?.title || null)

const activeList = computed(() =>
  filter(props.menu?.list, (list) => list.title == subMenu.value)
)

const handleSetSubMenu = (title: string) => {
  subMenu.value = title
}

const { locale } = useI18n()
</script>
